// Liens vers la liste des dossiers déjà filtrée (type d'affaire, juridiction).
// `vue=tous` demande à la liste de s'ouvrir sur « Tous les dossiers » : sinon
// elle garde « Mes dossiers » et la liste paraît incomplète.

export const DOSSIER_LIST_TYPE_PARAM = 'type';
export const DOSSIER_LIST_JURISDICTION_PARAM = 'juridiction';
export const DOSSIER_LIST_SCOPE_PARAM = 'vue';
export const DOSSIER_LIST_SCOPE_ALL = 'tous';

function listHref(param: string, value: string): string {
  const sp = new URLSearchParams();
  sp.set(param, value);
  sp.set(DOSSIER_LIST_SCOPE_PARAM, DOSSIER_LIST_SCOPE_ALL);
  return `/dossiers?${sp.toString()}`;
}

export function dossiersByTypeHref(type: string): string {
  return listHref(DOSSIER_LIST_TYPE_PARAM, type);
}

/** Le filtre porte sur le nom de la juridiction, unique dans la table `jurisdictions`. */
export function dossiersByJurisdictionHref(name: string): string {
  return listHref(DOSSIER_LIST_JURISDICTION_PARAM, name);
}

/** Valeurs d'un filtre multiple lues dans l'adresse (séparées par « | », un nom de juridiction peut contenir une virgule). */
export function readListParam(sp: URLSearchParams, param: string): string[] {
  return sp.getAll(param).flatMap((raw) => raw.split('|')).map((v) => v.trim()).filter(Boolean);
}

export function writeListParam(sp: URLSearchParams, param: string, values: string[]): URLSearchParams {
  const next = new URLSearchParams(sp);
  next.delete(param);
  if (values.length) next.set(param, values.join('|'));
  return next;
}
